import FloatingCourseActionsBar from '@/components/FloatingCourseActionsBar';
import GoBackMenu from '@/components/GoBackNavbar';
import Tab from '@/components/Tab';
import { ApplicationState } from '@/store';
import { getProgramClear } from '@/store/program/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import ProgramContents from './Contents';
import ProgramInfo from './Info';
import './style.scss';

const ManageProgram: React.FC = () => {
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const LMSPath = '/contents/lms/programs';
    useEffect(() => {
        return () => {
            dispatch(getProgramClear());
        };
    }, []);

    return (
        <>
            <div className="create-course">
                <GoBackMenu confirmable goBackPath={LMSPath} />
                <div className="title">
                    <h1>{id ? strings.EDIT_PROGRAM : strings.NEW_PROGRAM}</h1>
                </div>
                <div className="create-program__container">
                    <div className="tabs-container">
                        <Tab
                            active={!history.location.pathname.match(/(programs\s*)(.*)(contents)/)}
                            setActive={() => id && history.push(`${LMSPath}/${id}`)}
                            title={strings.GENERAL_INFORMATION}
                        />
                        <Tab
                            active={!!history.location.pathname.match(/(programs\s*)(.*)(contents)/)}
                            disabled={!id}
                            setActive={() => id && history.push(`${LMSPath}/${id}/contents`)}
                            title={strings.CONTENTS}
                        />
                    </div>

                    <div className="program-content">
                        <Switch>
                            <Route exact path={`${LMSPath}/:id`}>
                                <ProgramInfo />
                            </Route>
                            <Route exact path={`${LMSPath}/:id/contents`}>
                                <ProgramContents />
                            </Route>
                            <Route exact path={LMSPath}>
                                <ProgramInfo />
                            </Route>
                        </Switch>
                    </div>
                </div>
                <FloatingCourseActionsBar />
            </div>
        </>
    );
};

export default ManageProgram;
